import React, { useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from './Button';
import QrCodeViewer, { QrCodeViewerHandle } from './QRCodeViewer';
import { KeyFill, Download } from 'react-bootstrap-icons';
import { SubscriptionStatusPill } from './SubscriptionStatusPill';

interface QrCodeModalProps {
  show: boolean;
  onHide: () => void;
  value: string;
  height: number;
}

const QrCodeModal: React.FC<QrCodeModalProps> = ({ show, onHide, value, height }) => {
  const viewerRef = useRef<QrCodeViewerHandle>(null);

  const handleDownload = () => {
    viewerRef.current?.downloadPng();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Access QR Code</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className="rounded-3 d-flex align-items-start gap-2 mb-3 px-3 py-2"
          style={{ backgroundColor: 'color-mix(in srgb, var(--color-light) 28%, white)' }}
        >
          <div
            className="rounded flex-shrink-0 d-flex align-items-center justify-content-center text-white"
            style={{ width: 40, height: 40, backgroundColor: 'var(--color-mid)' }}
          >
            <KeyFill className="fs-5" />
          </div>
          <div>
            <div className="fw-semibold" style={{ color: 'var(--color-very-dark)' }}>
              Gate & Entry Access
            </div>
            <div className="small" style={{ color: 'var(--color-dark)' }}>
              Hold this code up to the scanner at the facility entrance or exit. The gate will open automatically once scanned.
            </div>
          </div>
        </div>
        <QrCodeViewer ref={viewerRef} value={value} height={height} />
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end gap-2">
        <Button className="btn-outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button className="btn-main" onClick={handleDownload}>
          <Download className="me-2 icon-shift-up" />
          Download
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QrCodeModal;
